<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead" style="text-indent: 0%;">Contents</h2>
<div class="contentsEntry" id="contentsEntry4" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/9781426852985_ch01#ch01">Chapter One</a></p></div>
<div class="contentsEntry" id="contentsEntry5" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781426852985_ch02#ch02" title="Link target outside of Sample">Chapter Two</span></p></div>
<div class="contentsEntry" id="contentsEntry6" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781426852985_ch03#ch03" title="Link target outside of Sample">Chapter Three</span></p></div>
<div class="contentsEntry" id="contentsEntry7" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781426852985_abs#abs" title="Link target outside of Sample">About the Author</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781426852985_con01.vue?3f489dc6